import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { HumanIcon, MailIcon, PhoneIcon } from 'components/SvgIcons';
import { Address } from 'components/Address';
import { formatPhone } from 'utils/formatPhone';

import './index.scss';

export default class ContactHuman extends PureComponent {
  static propTypes = {
    blockTitle: PropTypes.string,
    name: PropTypes.string,
    phoneNumber: PropTypes.string,
    ext: PropTypes.string,
    email: PropTypes.string,
    address: PropTypes.string,
    description: PropTypes.string,
    addClass: PropTypes.string,
    countryCode: PropTypes.string.isRequired,
  };
  static defaultProps = {
    countryCode: '',
  };

  render() {
    const {
      blockTitle,
      companyName,
      personName,
      name,
      customIcon,
      phoneNumber,
      ext,
      email,
      address,
      addressOtherText,
      description,
      addClass,
      countryCode,
    } = this.props;

    return (
      <div className={addClass}>
        {blockTitle && (
          <div className="flex align-items-center mb-3">
            {customIcon ? (
              customIcon
            ) : (
              <HumanIcon
                className="fill-persian-red mr-2 mw-20"
                width="21"
                height="21"
              />
            )}
            <h3>{blockTitle}</h3>
          </div>
        )}
        {name && (
          <div className="mb-3 human-name">
            <span
              className="montserrat semi-bold"
              data-testid="contact-human-name-value"
            >
              {name}
            </span>
          </div>
        )}
        {(companyName || personName) && (
          <div className="mb-4">
            <span
              className="montserrat semi-bold"
              data-testid="contact-human-company-name-value"
            >
              {companyName}
              {`, ${personName}`}
            </span>
          </div>
        )}
        {phoneNumber && (
          <div className="contact-info__phone flex">
            <a
              href={`tel:${phoneNumber}`}
              className="flex align-items-center text-decoration-none color-gray-dark"
              data-testid="contact-human-phone-value"
            >
              <PhoneIcon className="fill-gray-icon mr-2" />
              {countryCode
                ? formatPhone(phoneNumber, countryCode)
                : phoneNumber}
            </a>
            {ext && (
              <Fragment>
                <span
                  className="ml-6 fs-12 mr-2 flex align-items-flex-end"
                  style={{ color: '#474D55' }}
                >
                  ext.:
                </span>
                <span className="fs-14">{ext}</span>
              </Fragment>
            )}
          </div>
        )}
        {email && (
          <a
            href={`mailto:${email}`}
            className="mt-3 flex align-items-center text-decoration-none color-gray-dark"
            data-testid="contact-human-email-value"
          >
            <MailIcon className="fill-gray-icon mr-2" />
            {email}
          </a>
        )}
        {address && <Address className="mt-3" address={address} isContact />}
        {description && (
          <div
            className="mt-3 fs-12 lh-20 word-break"
            data-testid="contact-human-description-value"
          >
            {description}
          </div>
        )}
      </div>
    );
  }
}
